import { useTranslation } from "react-i18next";
import { AiArtwork } from "../data/aiArtworks";
import { aiCollectionCopy } from "../data/aiArtworkCatalog";
import {
  descriptionFromFile,
  titleFromFileEn,
  titleFromFileHe,
} from "../data/aiArtworkMeta";

function localeKey(language: string): "en" | "he" {
  return language?.startsWith("he") ? "he" : "en";
}

export function useAiArtwork(work: AiArtwork) {
  const { t, i18n } = useTranslation();
  const lang = localeKey(i18n.language);
  const collection = work.collection;
  const collectionLabel = aiCollectionCopy[collection][lang];

  const title =
    lang === "he" ? titleFromFileHe(work.imageFile) : titleFromFileEn(work.imageFile);

  return {
    ...work,
    title,
    name: `${collectionLabel} — ${title}`,
    description: descriptionFromFile(work.imageFile, lang),
    collectionLabel,
    medium: t("ai.medium"),
  };
}

export function useAiCollectionLabel(collection: AiArtwork["collection"]) {
  const { i18n } = useTranslation();
  const lang = localeKey(i18n.language);
  return aiCollectionCopy[collection][lang];
}

export { titleFromFileEn, titleFromFileHe };
